import React from 'react';

import classNames from 'classnames';

import { GRANULARITY_MONTH, GRANULARITY_QUARTER, GRANULARITY_YEAR } from '../hooks/useSummaryFilters';

const OPTIONS = [
    { id: GRANULARITY_MONTH, label: 'M' },
    { id: GRANULARITY_QUARTER, label: 'Q' },
    { id: GRANULARITY_YEAR, label: 'Y' },
];

export default function GranularityToggle({ value, onChange }) {
    return (
        <div>
            <div className="tw-text-sm tw-text-blue-75 tw-font-medium tw-mb-2">{$t('Granularity')}</div>
            <div className="tw-inline-flex tw-rounded-full tw-border-2 tw-border-blue tw-overflow-hidden" role="group">
                {OPTIONS.map((option) => (
                    <button
                        key={option.id}
                        type="button"
                        aria-pressed={value === option.id}
                        onClick={() => onChange(option.id)}
                        className={classNames('tw-px-4 tw-py-1 tw-text-sm tw-font-medium tw-transition-colors', {
                            'tw-bg-blue tw-text-white': value === option.id,
                            'tw-bg-white tw-text-blue': value !== option.id,
                        })}
                    >
                        {option.label}
                    </button>
                ))}
            </div>
        </div>
    );
}
